module.exports = __webpack_public_path__ + "img/boxBo1.61e5b64d.png";